<template>
    <b-row>
        <b-col>
            <datetime v-model="fullDateString"
                      type="date"
                      input-class="form-control"
                      :state="state"
                      value-zone="local"
                      v-if="isIE">
<!--                <b-button slot="after"-->
<!--                          :disabled="!fullDateString"-->
<!--                          @click="date = null">X-->
<!--                </b-button>-->
            </datetime>
<!--            <b-form-input :state="state"-->
<!--                          v-model="date"-->
<!--                          type="date"-->
<!--                          :disabled="disabled"-->
<!--                          v-if="!isIE"></b-form-input>-->
            <v-text-field outlined
                          :state="state"
                          v-model="date"
                          type="date"
                          :disabled="disabled"
                          :label="label"
                          :placeholder="placeholder"
                          v-if="!isIE"
                          v-bind="$attrs"></v-text-field>
            <!--            <b-form-input :state="state" v-model="date" type="date" :disabled="disabled"></b-form-input>-->
        </b-col>
    </b-row>
</template>

<script>
    import {DateTime} from "luxon";

    export default {
        name: 'DateInput',
        props: {
            value: [Date, String],
            disabled: Boolean,
            state: {
                type: Boolean,
                default: null,
            },
            label: String,
            placeholder: String,
        },
        data() {
            return {
                fullDateString: null,
                fullTimeString: null,
                date: null,
                time: null,
            }
        },
        mounted() {
            if (this.value) {
                if (this.value instanceof Date) {
                    let d = DateTime.fromJSDate(this.value);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                } else {
                    let d = DateTime.fromISO(this.value);
                    this.fullDateString = d.toISODate();
                    this.fullTimeString = d.toFormat('HH:mm');
                    this.date = d.toISODate();
                    this.time = d.toFormat('HH:mm');
                }
            }
        },
        computed: {
            isIE() {
                let userAgent = window.navigator.userAgent;
                var msie = userAgent.indexOf("MSIE ");

                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
                {
                    return true;
                } else {
                    return false;
                }
            },
        },
        watch: {
            value(newVal) {
                let d = newVal instanceof Date ? DateTime.fromJSDate(newVal) : DateTime.fromISO(newVal);
                this.fullDateString = d.toISODate();
                this.fullTimeString = d.toFormat('HH:mm');
                this.date = d.toISODate();
                this.time = d.toFormat('HH:mm');
            },
            fullDateString(newVal) {
                if (newVal && newVal.length !== 10) {
                    this.date = DateTime.fromISO(newVal).toISODate();
                } else {
                    this.emitIfValid();
                }
            },
            fullTimeString(newVal) {
                if (newVal && newVal.length !== 10) {
                    this.time = DateTime.fromISO(newVal).toFormat('HH:mm');
                } else {
                    this.emitIfValid();
                }
            },
            date() {
                this.emitIfValid();
            },
            time() {
                this.emitIfValid();
            },
        },
        methods: {
            emitIfValid() {
                let date = DateTime.fromISO(this.date);
                if (!date.invalid) {
                    this.$emit('input', date.toISO());
                } else {
                    this.$emit('input', null);
                }
            },
        },
    }
</script>

<style lang="less">
.container {
    .col {
        padding-top: 0px;
    }
}
</style>
